import React from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';

function BuildWebsitePage() {
    const { t } = useTranslation();

    return (
        <>
            <Helmet>
                <title>{t('titles.build-a-website')}</title>
            </Helmet>
            <div className="build-website-page">
                <h1>Build A Website Page</h1>
            </div>
        </>
    );
}

export default BuildWebsitePage;
